import { useEffect } from 'react';
import appboy from '@braze/web-sdk';
import { useSelector } from 'react-redux';
import { world } from '../languages';
import Braze from '../utils/braze';

const useBraze = () => {
    const user = useSelector((state: RootState) => state.main.user);

    useEffect(() => {
        appboy.enableSDK();
        const envConfig = Braze.availableEnvConfig();

        if (user.id && envConfig?.id) {
            appboy.initialize(envConfig.id, {
                baseUrl: envConfig.baseUrl,
                // enableLogging: true,
                allowUserSuppliedJavascript: true,
                minimumIntervalBetweenTriggerActionsInSeconds: 5
            });
            appboy.wipeData();
            appboy.changeUser(user.id.toString());
            appboy.display.automaticallyShowNewInAppMessages();
            appboy.logCustomEvent('website_opened', { country: world });
            appboy.openSession();
        }
    }, [user.id]);
};

export default useBraze;
